import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import { USER_SETTINGS_KEY } from "core/local_storage_utils";
import { parseJsonString } from "core/str_utils";
import { viewModes } from "pages/Som/SomDb/Ribbon/SomDbRibbonSettings";

import { changeRowDataRecourse } from "../utils";
import { fetchSomDbStats } from "./services/fetchSomDbStats";
import { fetchSomDbTableData } from "./services/fetchSomDbTableData";

export const verifiedStatus = { id: 2, name: "Верифицированная" };

const initialState = () => {
	const userSettings = parseJsonString(localStorage.getItem(USER_SETTINGS_KEY));

	return {
		tableData: [],
		columnsData: [],
		filterRows: [],
		filterParams: [],
		initColumns: false,
		withEmptyChars: userSettings?.somDb?.withEmptyChars ?? true,
		expandedSomItemChars: false,
		expandedSomItemSuppliers: false,
		expandedSomItemFilter: false,
		expandedSomItemProjectDocs: false,
		fetchStatus: "",
		fetchRibbonStatus: null,
		fetchStatusText: undefined,
		selectedViewMode: userSettings?.somDb?.selectedViewMode ?? viewModes[0],
		selectedClassifier: null,
		shouldClearFilter: false,
		selectedStatus: userSettings?.somDb?.selectedStatus ?? [verifiedStatus],
		statisticView: false,
	};
};

export const somDbSlice = createSlice({
	name: "somDb",
	initialState,
	reducers: {
		setTableData: (state, { payload }) => {
			state.tableData = payload;
		},
		setColumnsData: (state, { payload }) => {
			state.columnsData = payload;
		},
		setInitColumns: (state) => {
			state.initColumns = true;
		},
		setWithEmptyChars: (state, { payload }) => {
			state.withEmptyChars = payload;
		},
		setExpandedSomItemChars: (state, { payload }) => {
			state.expandedSomItemChars = payload;
		},
		setExpandedSomItemSuppliers: (state, { payload }) => {
			state.expandedSomItemSuppliers = payload;
		},
		setExpandedSomItemFilter: (state, { payload }) => {
			state.expandedSomItemFilter = payload;
		},
		setExpandedSomItemProjectDocs: (state, { payload }) => {
			state.expandedSomItemProjectDocs = payload;
		},
		setSelectedViewModes: (state, { payload }) => {
			state.selectedViewMode = payload;
		},
		setFilterParams: (state, { payload }) => {
			state.filterParams = payload;
		},
		setFetchStatus: (state, { payload }) => {
			state.fetchStatus = payload;
		},
		setFetchStatusText: (state, { payload }) => {
			state.fetchStatusText = payload;
		},
		setFilterRows: (state, { payload }) => {
			state.filterRows = payload;
		},
		setSelectedClassifier: (state, { payload }) => {
			state.selectedClassifier = payload;
		},
		setShouldClearFilter: (state, { payload }) => {
			state.shouldClearFilter = payload;
		},
		setSelectedStatus: (state, { payload }) => {
			state.selectedStatus = payload;
		},
		setStatisticView: (state, { payload }) => {
			state.statisticView = payload;
		},
		setFetchRibbonStatus: (state, { payload }) => {
			state.fetchRibbonStatus = payload;
		},
		changeTableRowData: (state, { payload: { rowKey, callback } }) => {
			state.tableData = changeRowDataRecourse(state.tableData, rowKey, callback);
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(isAnyOf(fetchSomDbTableData.pending, fetchSomDbStats.pending), (state) => {
			state.tableData = [];
			state.fetchRibbonStatus = "loading";
		});
		builder.addMatcher(isAnyOf(fetchSomDbTableData.fulfilled, fetchSomDbStats.fulfilled), (state, { payload }) => {
			state.tableData = payload;
			state.fetchRibbonStatus = null;
		});
		builder.addMatcher(isAnyOf(fetchSomDbTableData.rejected, fetchSomDbStats.rejected), (state) => {
			state.fetchRibbonStatus = null;
			state.fetchStatus = "failed";
		});
	},
});

export const { actions: somDbActions, reducer: somDbReducer } = somDbSlice;
